import React from 'react';
import { LogOut, Settings, HardDrive } from 'lucide-react';
import styles from './ProfileDropdown.module.css';
import { useNavigate } from 'react-router-dom';

export default function ProfileDropdown({ onSelect, visible, onVisibleChange }) {
  const navigate = useNavigate();

  if (!visible) return null;

  const handleItemClick = (action) => {
    if (action === 'settings') {
      navigate('/settings');
      onVisibleChange(false);
      return;
    }
    if (action === 'data-management') {
      navigate('/data-management');
      onVisibleChange(false);
      return;
    }
    onSelect(action);
    onVisibleChange(false);
  };

  return (
    <div className={styles.dropdownContainer}>
      <div className={styles.dropdownMenu}>
        <div 
          className={styles.menuItem} 
          onClick={() => handleItemClick('settings')}
        >
          <span className={styles.menuIcon}><Settings size={18} /></span>
          <span className={styles.menuText}>Settings</span>
        </div>

        <div 
          className={styles.menuItem} 
          onClick={() => handleItemClick('data-management')}
        >
          <span className={styles.menuIcon}><HardDrive /></span>
          <span className={styles.menuText}>Data Management</span>
        </div>

        <div className={styles.divider} />

        <div 
          className={styles.menuItem} 
          onClick={() => handleItemClick('logout')}
        >
          <span className={styles.menuIcon}><LogOut size={18} /></span>
          <span className={styles.menuText}>Log Out</span>
        </div>
      </div>
    </div>
  );
}
